import script from "./ArticleCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleCard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__